export const backendTableToTariffsItems = backendData => {
    const table = backendData && Array.isArray(backendData.data) && backendData.data[0];
    if (!table) return [];

    const columns = Array.isArray(table.columns)
        ? table.columns.slice().sort((a, b) => a.id - b.id)
        : [];
    const rows = Array.isArray(table.rows) ? table.rows.slice().sort((a, b) => a.id - b.id) : [];
    const cells = Array.isArray(table.cells) ? table.cells : [];

    if (!columns.length || !rows.length) return [];

    const headerLabel = columns[0].column_name ? columns[0].column_name : '';
    const headerRest = columns.slice(1).map(col => (col.column_name ? col.column_name : ''));

    const headerItem =
        headerRest.length === 1
            ? {label: headerLabel, value: headerRest[0]}
            : {label: headerLabel, values: headerRest};

    const rowItems = rows.map(row => {
        const allValues = columns.map(col => {
            const cell = cells.find(c => c.row_id === row.id && c.column_id === col.id);
            return cell && cell.cell_value ? cell.cell_value : '';
        });

        const label = allValues[0];
        const restValues = allValues.slice(1);

        return restValues.length === 1
            ? {label: label, value: restValues[0]}
            : {label: label, values: restValues};
    });

    return [headerItem, ...rowItems];
};
